import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function UserTerms() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = [
    {
      number: "1",
      title: t("userTerms.s1.title"),
      content: (
        <>
          <p>{t("userTerms.s1.p1")}</p>
          <p>{t("userTerms.s1.p2")}</p>
        </>
      ),
    },
    {
      number: "2",
      title: t("userTerms.s2.title"),
      content: (
        <>
          <p>{t("userTerms.s2.p1")}</p>
          <p>{t("userTerms.s2.p2")}</p>
          <p>{t("userTerms.s2.p3")}</p>
          <p>{t("userTerms.s2.p4")}</p>
        </>
      ),
    },
    {
      number: "3",
      title: t("userTerms.s3.title"),
      content: (
        <>
          <p>{t("userTerms.s3.p1")}</p>
          <p>{t("userTerms.s3.p2")}</p>
          <p>{t("userTerms.s3.p3")}</p>
        </>
      ),
    },
    {
      number: "4",
      title: t("userTerms.s4.title"),
      content: (
        <>
          <p>{t("userTerms.s4.p1")}</p>
          <p>{t("userTerms.s4.p2")}</p>
          <p>{t("userTerms.s4.p3")}</p>
          <ul>
            <li>{t("userTerms.s4.l1")}</li>
            <li>{t("userTerms.s4.l2")}</li>
          </ul>
          <p>{t("userTerms.s4.p4")}</p>
          <p>{t("userTerms.s4.p5")}</p>
          <p>{t("userTerms.s4.p6")}</p>
        </>
      ),
    },
    {
      number: "5",
      title: t("userTerms.s5.title"),
      content: (
        <>
          <p>{t("userTerms.s5.p1")}</p>
          <p>{t("userTerms.s5.p2")}</p>
        </>
      ),
    },
    {
      number: "6",
      title: t("userTerms.s6.title"),
      content: (
        <>
          <p>{t("userTerms.s6.p1")}</p>
          <p>{t("userTerms.s6.p2")}</p>
        </>
      ),
    },
    {
      number: "7",
      title: t("userTerms.s7.title"),
      content: (
        <>
          <p>{t("userTerms.s7.intro")}</p>
          <ul>
            <li>{t("userTerms.s7.l1")}</li>
            <li>{t("userTerms.s7.l2")}</li>
            <li>{t("userTerms.s7.l3")}</li>
            <li>{t("userTerms.s7.l4")}</li>
            <li>{t("userTerms.s7.l5")}</li>
          </ul>
          <p>{t("userTerms.s7.p2")}</p>
        </>
      ),
    },
    {
      number: "8",
      title: t("userTerms.s8.title"),
      content: (
        <>
          <p>{t("userTerms.s8.intro")}</p>
          <ul>
            <li>{t("userTerms.s8.l1")}</li>
            <li>{t("userTerms.s8.l2")}</li>
            <li>{t("userTerms.s8.l3")}</li>
            <li>{t("userTerms.s8.l4")}</li>
            <li>{t("userTerms.s8.l5")}</li>
            <li>{t("userTerms.s8.l6")}</li>
          </ul>
          <p>{t("userTerms.s8.p2")}</p>
        </>
      ),
    },
    {
      number: "9",
      title: t("userTerms.s9.title"),
      content: (
        <>
          <p>{t("userTerms.s9.p1")}</p>
          <p>{t("userTerms.s9.p2")}</p>
          <p>{t("userTerms.s9.p3")}</p>
        </>
      ),
    },
    {
      number: "10",
      title: t("userTerms.s10.title"),
      content: (
        <>
          <p>{t("userTerms.s10.p1")}</p>
          <p>{t("userTerms.s10.p2")}</p>
        </>
      ),
    },
    {
      number: "11",
      title: t("userTerms.s11.title"),
      content: (
        <>
          <p>{t("userTerms.s11.p1")}</p>
          <p>{t("userTerms.s11.p2")}</p>
          <p>{t("userTerms.s11.p3")}</p>
          <p>{t("userTerms.s11.p4")}</p>
        </>
      ),
    },
    {
      number: "12",
      title: t("userTerms.s12.title"),
      content: <p>{t("userTerms.s12.p1")}</p>,
    },
    {
      number: "13",
      title: t("userTerms.s13.title"),
      content: (
        <>
          <p>{t("userTerms.s13.p1")}</p>
          <p>{t("userTerms.s13.p2")}</p>
          <p>{t("userTerms.s13.p3")}</p>
        </>
      ),
    },
  ];

  return (
    <>
      <SEO
        title="TransCirox – Allgemeine Geschäftsbedingungen | AGB für Kunden"
        description="Allgemeine Geschäftsbedingungen (AGB) der TransCiroX GmbH für Kunden und Privatpersonen."
        keywords="AGB, Allgemeine Geschäftsbedingungen, Kunden, TransCiroX"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("userTerms.agb")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>
                  {t("userTerms.title")}
                  <br />
                  {t("userTerms.subtitle")}
                </h1>

                {/* <div className="document-meta d-flex gap-3">
                  <span>{t("userTerms.validFrom")}: {t("userTerms.validDate")}</span>
                  <span>|</span>
                  <span>{t("userTerms.version")}: {t("userTerms.versionNumber")}</span>
                </div> */}

                <p>
                  {t("userTerms.company")}, {t("userTerms.address")}
                </p>

                <div className="document-meta d-flex gap-3">
                  <span>{t("userTerms.email")}: <a href="mailto:kontakt@transcirox.com">kontakt@transcirox.com</a></span>
                  <span>|</span>
                  <span>{t("userTerms.website")}: <a href="https://www.transcirox.com">www.transcirox.com</a></span>
                </div>

                <hr />

                {sections.map((section) => (
                  <div key={section.number} className="document-section">
                    <h3>
                      §{section.number} {section.title}
                    </h3>
                    <div>{section.content}</div>
                    <hr />
                  </div>
                ))}
              </div>

              {/* Footer */}
              {/* <div className="terms-footer">
                <div className="document-meta">
                  <div>{t("userTerms.validFrom")}: {t("userTerms.validDate")}</div>
                  <div>{t("userTerms.version")}: {t("userTerms.versionNumber")}</div>
                </div>
              </div> */}
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}